export default "__VITE_ASSET__DdXwlEzl__"